module.exports = __webpack_public_path__ + "static/wave.4c4d6776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wave.png
// module id = 438
// module chunks = 114276838955818